import type {
  CollectionRemoveOrderRequestType,
  CollectionRemoveOrderResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCollectionRemoveOrder = (collectionId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CollectionRemoveOrderRequestType) =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `collection/${collectionId}/remove-order`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as CollectionRemoveOrderResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Collections,
          collectionId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Collections],
      });
    },
  });
};
